// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// CSS
import '@/static/css/style.css'
// VueX
import store from '@/store'
// VeeValidate
import VeeValidate, { Validator } from 'vee-validate'
// Aixos OK
import '@/api/config.js'

import VueHighcharts from 'vue-highcharts'
import VueClipboards from 'vue-clipboards'

// Filter
import * as filters from '@/filters'

import locale from 'element-ui/lib/locale/lang/vi'

// VeeValidate
import localeVeeValidate from 'vee-validate/dist/locale/vi'
Validator.localize('vi', localeVeeValidate)
Vue.use(VeeValidate, { inject: false })

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

// element-ui
Vue.use(ElementUI, { locale })
Vue.use(VueHighcharts)
Vue.use(VueClipboards)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js